import React, { useEffect, useState } from 'react';
import SearchPanel from './SearchPanel';
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer } from 'react-toastify';
const HeaderDashboard = (props) => {
    const [progress, setProgress] = useState(props.progress);
    useEffect(() => {
        var addBodyDashboardClass = document.getElementsByTagName('body');
        addBodyDashboardClass[0].classList.add('dashboardWrapperCustom');
    });

    useEffect(() => {

        

    }, []);
   
    return (<>
        
        <LoadingBar color="#38a668" progress={100} onLoaderFinished={() => setProgress(0)} />
        <ToastContainer />
        <div className="HeaderCard">
            <div className="pagetitle">
                {props.title}
            </div>
            <SearchPanel />
        </div>
    </>)
}

export default HeaderDashboard;